import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { Spinner } from 'reactstrap'
import Decimal from 'decimal.js'

import ProgressBar from 'components/ProgressBar'
import { STRING } from 'resources'
import getDecimalValue from 'utils/get-decimal-value'

import { StepTrackerContainer, ProgressBarContainer, SpinnerContainer, TextContainer, StepText } from './styles'

const getStepValues = (value) => ({
  decimal: value != null ? getDecimalValue(value) : null,
  display: value ?? STRING.emDash,
})

const StepTracker = ({ color, height, completedSteps, totalSteps }) => {
  const [fallback, setFallback] = useState(false)
  const isStepCountMissing = !completedSteps || !totalSteps
  const showLoading = isStepCountMissing && !fallback
  const completed = getStepValues(completedSteps)
  const total = getStepValues(totalSteps)
  const progress =
    (completed.decimal && total.decimal && completed.decimal.div(total.decimal).mul(100)) || new Decimal(0)
  const progressLabelText = `${completed.display} / ${total.display}`

  useEffect(() => {
    if (!isStepCountMissing) {
      setFallback(false)
    }

    const timer = setTimeout(() => {
      setFallback(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [isStepCountMissing])

  return (
    <StepTrackerContainer>
      <ProgressBarContainer>
        <ProgressBar color={color} height={height} progress={progress.toNumber()} />
      </ProgressBarContainer>
      {showLoading ? (
        <SpinnerContainer>
          <Spinner size="sm" />
        </SpinnerContainer>
      ) : (
        <TextContainer>
          <StepText>{progressLabelText}</StepText>
        </TextContainer>
      )}
    </StepTrackerContainer>
  )
}

StepTracker.propTypes = {
  color: PropTypes.string.isRequired,
  height: PropTypes.number.isRequired,
  completedSteps: PropTypes.number,
  totalSteps: PropTypes.number,
}

export default StepTracker
